<!--
 * @Description: 
 * @Author: knx-xc
 * @LastEditTime: 2020-09-27 14:19:43
 * @LastEditors: knx-xc
--> 
<template>
  <div class="contact">
    <PageTitle></PageTitle>
    <Bread :breads="[{name:'联系我们',path:''}]"></Bread>
    <!-- animated -->
    <div class="content container-body  fadeInUp">
      <!-- <div id="allmap" class="allmap" style="width:739px;height:571px;"></div> -->
      <div id="allmap" class="allmap" ></div>
      <ul class="form">
        <li v-for="item in information" :key="item.title">
          <div>
            <img :src="item.icon" alt=""> <span v-text="item.title"></span>
          </div>
          <p v-if="item.title =='地址'" v-text="item.detail"></p>
          <h1 v-else v-text="item.detail"></h1>
        </li>
        <li>
          <h6>你也可以留下联系方式</h6>
          <el-form :model="form" class="demo-form-inline" ref="form" :rules="rules">
            <el-form-item prop="userName">
              <el-input prefix-icon="el-icon-user-solid" clearable v-model="form.userName" placeholder="姓名" maxlength="20"></el-input>
            </el-form-item>
            <el-form-item prop="mobile">
              <el-input prefix-icon="el-icon-mobile-phone" placeholder="手机号码" v-model="form.mobile" maxlength="11"></el-input>
            </el-form-item>
            <el-form-item style="text-align:right">
              <el-button type="primary" @click="onSubmit">提交</el-button>
            </el-form-item>
          </el-form>
        </li>
      </ul>
    </div>
  </div>
</template>
 
<script>
import { save_customer_info } from "../../../request/api.user/all.js"
import PageTitle from '@/components/user/PageTitle'
export default {
  name: '',
  components: { PageTitle },
  data() {
    var validateMobile = (rule, value, callback) => {
      let reg = /^1[3456789]\d{9}$/
      if (!reg.test(value)) {
        callback(new Error('手机号格式错误'))
      } else {
        callback()
      }
    }
    return {
      form: {
        userName: '',
        mobile: "",
        page:'CONTACT_US',
        pageUrl:'',
        fromDevice:'PC'
      },
      rules: {
        userName: [
          { required: true, message: '请填写联系人姓名', trigger: 'blur' },
          { required: true, message: '请填写联系人姓名', trigger: 'change' },
        ],
        mobile: [
          { required: true, message: '请填写联系人电话', trigger: 'blur' },
          { required: true, message: '请填写联系人电话', trigger: 'change' },
          { validator: validateMobile, trigger: 'blur' }
        ]
      },
      information: [
        {
          icon: require("../../../assets/images/contact/location-icon.png"),
          title: '地址',
          detail: '重庆市南岸区东本工业园A8-7-1',
        },
        {
          icon: require("../../../assets/images/contact/call-icon.png"),
          title: '联系电话',
          detail: '400-803-0527'
        }
      ]
    }
  },

  created() {
  },  
  mounted() {
    this.initMap();
  },
  methods: {
    onSubmit() {
      this.$refs['form'].validate().then(res => {
        this.form['pageUrl'] = window.location.href;
        save_customer_info(this.form).then(res => {
          if (res.code === 0) {
            this.$message({
              message:"提交成功,等候客户联系咨询详情",
              type:'success',
              duration:3000
            })
            this.$nextTick(()=>{
              this.$refs['form'].resetFields();
            })
          }
        }).then(() => {
        })
      }).catch(err => {
        this.$message.warning('请完善信息')
      })
    },
    // 初始化地图实例
    initMap() {
      let map = new AMap.Map(document.getElementById("allmap"), {
        zoom: 14,  //设置地图显示的缩放级别  取值范围[3-19]
        // center: [_this.center.lng, _this.center.lat],
        center: [106.652569, 29.479756],
        // 106.65272,29.480106   106.652569,29.479756
        viewMode: '3D',  //设置地图模式
        lang: 'zh_cn',  //设置地图语言类型
        resizeEnable: true,
      });
      var marker = new AMap.Marker({
        position: new AMap.LngLat(106.652569, 29.47975),   // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
        title: '重庆'
      });
      var circle = new AMap.Circle({
        center: new AMap.LngLat(106.652569, 29.47975),  // 圆心位置
        radius: 1000, // 圆半径
        fillColor: '#dadeed',   // 圆形填充颜色
        fillOpacity: "0.5",
        strokeColor: '#1C84D4', // 描边颜色
        strokeWeight: 2, // 描边宽度
      });

      map.add([circle, marker]);


    },
  }
}
</script>
 
<style  lang="less" rel="stylesheet/less"  scoped>
.contact {
  .content {
    margin-bottom: 40px;
    display: flex;
    align-items: center;
    background: #ffffff;
    .allmap{
      width: 739px;
      height: 571px;
    }
    ul.form {
      // width: 400px;
      flex: 1;
      height: 100%;
      text-align: left;
      padding: 14px 30px;
      li {
        div {
          img {
            width: 40px;
            height: 40px;
            margin-right: 10px;
          }
          span {
            font-size: 40px;
            color: #1c84d4;
            font-weight: bold;
          }
        }
        p {
          margin-top: 20px;
          margin-bottom: 40px;
          color: #333333;
          font-size: 20px;
          font-weight: bold;
          line-height: 32px;
        }
        h1 {
          margin-top: 20px;
          font-size: 40px;
          color: #e88015;
        }
        h6 {
          margin: 25px 0;
          color: #333333;
          font-size: 20px;
          font-weight: bold;
          line-height: 32px;
        }
      }
    }
  }
}
</style>